/**
 * Layout store — preferințe UI pentru chrome-ul principal.
 * - sidebarCollapsed: toggle sidebar între 240px (expanded) și 56px (collapsed)
 * Persistă în localStorage.
 */
import { create } from 'zustand';

const STORAGE_KEY = 'cerbes-sidebar-collapsed';

function read(): boolean {
  try {
    return localStorage.getItem(STORAGE_KEY) === 'true';
  } catch {
    return false;
  }
}

interface LayoutState {
  sidebarCollapsed: boolean;
  toggleSidebar: () => void;
  setSidebarCollapsed: (collapsed: boolean) => void;
}

export const useLayoutStore = create<LayoutState>((set, get) => ({
  sidebarCollapsed: read(),
  toggleSidebar: () => {
    const next = !get().sidebarCollapsed;
    try {
      localStorage.setItem(STORAGE_KEY, String(next));
    } catch {
      // ignore
    }
    set({ sidebarCollapsed: next });
  },
  setSidebarCollapsed: (collapsed) => {
    try {
      localStorage.setItem(STORAGE_KEY, String(collapsed));
    } catch {
      // ignore
    }
    set({ sidebarCollapsed: collapsed });
  },
}));
